export const GenderSwitchToggle = (gender, componentType) => ({
    event: `select gender toggle - ${gender}`,
    effect: 'gender toggle clicked',
    category: {
        primaryCategory: 'gender toggle selection',
        subCategory: componentType
    }
});
